import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useTableStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    // minHeight: '100%',
    height: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  cardContainer: {
    padding: '20px 35px',
  },
}));

export default useTableStyles;
